import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import RichTextPreview from 'src/components/Submission/GenericFieldComponents/RichText/RichTextPreview';
import { removeHrefKeepText } from 'src/utils/email.utils';

interface InvitationPreviewProps {
  body: string;
  subject: string;
}

export const InvitationPreviewNew: React.FC<InvitationPreviewProps> = ({
  body,
  subject
}) => {
  return (
    <Flex
      borderWidth="1px"
      borderStyle="solid"
      borderColor="neutralSecondaryBorder"
      borderRadius="small"
      backgroundColor="surfaceSecondaryFill"
      padding={4}
      flexDirection="column"
      gap={2}
      minWidth={0}
      overflow="hidden"
      wordBreak="break-word"
    >
      <Box fontWeight="semibold">
        <RichTextPreview value={removeHrefKeepText(subject)} />
      </Box>

      <Box opacity={0.8}>
        <RichTextPreview value={removeHrefKeepText(body)} />
      </Box>
    </Flex>
  );
};

export default InvitationPreviewNew;
